import { render, staticRenderFns } from "./AddRoleForm.vue?vue&type=template&id=fa24df62&"
import script from "./AddRoleForm.vue?vue&type=script&lang=js&"
export * from "./AddRoleForm.vue?vue&type=script&lang=js&"
import style0 from "./AddRoleForm.vue?vue&type=style&index=0&id=fa24df62&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports
import {QForm,QInput} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QInput})
